/**
 * XO Club - Query Client Configuration
 * =====================================
 * Configuration centralisée de React Query.
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache les données pendant 5 minutes
      staleTime: 5 * 60 * 1000,
      // Garde les données en cache pendant 10 minutes
      gcTime: 10 * 60 * 1000,
      // Retry 2 fois en cas d'erreur
      retry: 2,
      // Ne pas refetch en arrière-plan
      refetchOnWindowFocus: false,
      // Ne pas refetch au montage si les données sont fraîches
      refetchOnMount: false,
    },
    mutations: {
      // Retry 1 fois pour les mutations
      retry: 1,
    },
  },
});
